import { LocalDemographicsProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  LocalDemographicsProps["options"],
  OptionalPropertyOf<LocalDemographicsProps["options"]>
> = {};

export default defaultState;
